// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"95":"4529ae1104b632e56ff9","120":"76e0d20db3250831e68b","459":"f09f8d78859296220fee","856":"6605062fdc139f40aefb"}[chunkId] + ".js";
};